import _ from 'lodash';
import React, { useState, type JSX } from 'react';
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';
import { DateTime } from 'luxon';
interface DatePickerProps {
    setDate: React.Dispatch<React.SetStateAction<string | null>>;
    selectedDate:string | null;
    availableDates?: string[];
    onChange?: (dates: Date[]) => void;
}

const DatePicker: React.FC<DatePickerProps> = ({ setDate, selectedDate, availableDates, onChange }) => {
        const [currentDate, setCurrentDate] = useState<Date>(() => {
        const hkNow = DateTime.now().setZone('Asia/Hong_Kong');
        return new Date(hkNow.year, hkNow.month - 1, hkNow.day);
    });
        const hkNow = DateTime.now().setZone('Asia/Hong_Kong');
    const nowMonth = hkNow.month - 1;
    const nowYear = hkNow.year;
    const nowday = hkNow.day;

    // Precompute if back button should be disabled
    const isBackDisabled = currentDate.getFullYear() === nowYear && currentDate.getMonth() <= nowMonth;

    const daysInMonth = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth() + 1,
        0
    ).getDate();

    const firstDayOfMonth = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        1
    ).getDay();

    const months: string[] = [
        "january", "february", "march", "april", "may", "june",
        "july", "august", "september", "october", "november", "december"
    ];

    const generateDays = (): JSX.Element[] => {
        const days: JSX.Element[] = [];
        for (let i = 0; i < firstDayOfMonth; i++) {
            days.push(<div key={`empty-${i}`} className="day-cell"></div>);
        }
        for (let day = 1; day <= daysInMonth; day++) {
                        const date = new Date(currentDate.getFullYear(), currentDate.getMonth(), day);
            const dateISO = DateTime.fromJSDate(date, { zone: 'Asia/Hong_Kong' }).toISODate();
            const isSelected = selectedDate === dateISO;
            const isDisabled = availableDates ? !availableDates.includes(dateISO || '') : false;
            days.push(
                <button
                    key={day}
                    onClick={() => handleDateClick(date)}
                    className={`btn day-cell d-flex align-items-center justify-content-center p-0 rounded-circle text-black ${isSelected ? 'bg-primary text-white' : 'bg-transparent text-title'
                        } ${((isBackDisabled && day < nowday) || isDisabled) ? 'fw-normal' : 'fw-bold'}`}
                    style={{ width: '2.5rem', height: '2.5rem' }}
                    disabled={(isBackDisabled && day < nowday) || isDisabled}
                >
                    {day}
                </button>
            );
        }
        return days;
    };

    const handleDateClick = (date: Date): void => {
        const hkDate = DateTime.fromJSDate(date, { zone: 'Asia/Hong_Kong' }).toISODate();
        setDate(hkDate || null);

    };

    const navigateMonth = (direction: number): void => {
        setCurrentDate(prev => new Date(
            prev.getFullYear(),
            prev.getMonth() + direction,
            1
        ));
    };

    return (
        <div className="w-100">
            <div className="p-3">
                <div className="d-flex align-items-center justify-content-between mb-4">
                    <button
                        onClick={() => navigateMonth(-1)}
                        className="btn btn-link text-decoration-none"
                        disabled={isBackDisabled}
                        style={{ visibility: isBackDisabled ? 'hidden' : 'visible' }}
                    >
                        <IoIosArrowBack className="dateArrow" />
                    </button>

                    <h6 className="mb-0 heading">
                        {_.startCase(months[currentDate.getMonth()])} {currentDate.getFullYear()}
                    </h6>

                    <button
                        onClick={() => navigateMonth(1)}
                        className="btn btn-link text-decoration-none"
                    >
                        <IoIosArrowForward className="dateArrow" />
                    </button>
                </div>

                <div className="calendar">
                    <div className="d-grid" style={{
                        gridTemplateColumns: 'repeat(7, 1fr)',
                        gap: '0.5rem'
                    }}>
                        {['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'].map(day => (
                            <div
                                key={day}
                                className="text-center text-primary small"
                            >
                                {_.startCase(day)}
                            </div>
                        ))}
                        {generateDays()}
                    </div>
                </div>
            </div>

            <style>
                {`
          .day-cell {
            aspect-ratio: 1;
            border: none;
          }
          .btn-outline-light:hover {
            background-color: #f8f9fa;
          }
          .calendar .btn:focus {
            box-shadow: none;
          }
        `}
            </style>
        </div>
    );
};

export default DatePicker;